import { captureException } from '@sentry/react';

/**
 * `capAt` is the threshold above which the number will be
 * displayed using Intl.NumberFormat's compact notation.
 */
export function capAndFormatNumber(
  num: number,
  options?: Intl.NumberFormatOptions & { capAt?: number; suffix?: string }
) {
  try {
    const { capAt = 99_999, suffix = '+', ...formatOptions } = options || {};

    if (isNaN(num)) {
      const error = new Error('capAndFormatNumber requires a valid number');
      captureException(error);
      return '0';
    }

    if (num < 0) {
      throw new Error('capAndFormatNumber does not support negative numbers');
    }

    if (!isFinite(num)) {
      const formattedCap = new Intl.NumberFormat(
        undefined,
        formatOptions
      ).format(Math.abs(capAt));
      return `${formattedCap}${suffix}`;
    }

    const shouldCap = num > capAt;

    const formattedNumber = new Intl.NumberFormat(undefined, {
      ...(shouldCap ? { notation: 'compact' } : {}),
      ...formatOptions,
    }).format(num);

    return shouldCap ? `${formattedNumber}${suffix}` : formattedNumber;
  } catch (error) {
    captureException(error);
    return num.toString();
  }
}
